import { render, staticRenderFns } from "./order-confirmation-short-id-wrapper.vue?vue&type=template&id=7184b451&scoped=true&"
import script from "./order-confirmation-short-id-wrapper.vue?vue&type=script&lang=js&"
export * from "./order-confirmation-short-id-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./order-confirmation-short-id-wrapper.vue?vue&type=style&index=0&id=7184b451&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7184b451",
  null
  
)

export default component.exports